// eslint-disable-next-line import/prefer-default-export
export const quantityValidator = (t, smallestUnit, maximumBidSize) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (input.trim().length === 0) {
        err = t('auctions.bids-list.validation.quantity-empty');
    } else if (!input.match(/^\d+$/)) {
        err = t('auctions.bids-list.validation.quantity-invalid-integer');
    } else if (parsedInput < smallestUnit || parsedInput > maximumBidSize) {
        err = t('auctions.bids-list.validation.quantity-out-of-range', { smallestUnit, maximumBidSize });
    } else if (parsedInput % smallestUnit > 0) {
        err = t('auctions.bids-list.validation.quantity-not-multiple', { smallestUnit });
    }
    return err;
};
